<template>
  <div :key="tableRenderKey" id="sys-data-table" class="br-3px" @contextmenu="contextmenu">
    <TTitle :title="title" :itensFiltrados="itensFiltrados">
      <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"><slot :name="slot" v-bind="scope"/></template>
    </TTitle>

    <div id="sys-data-table-body" :style="styleContentTable" :class="classScroll" @scroll="onScrollTable" ref="contentTableRef">
      <div :style="{ marginBottom: `${heightRowHelpBottom}px` }">
        <table :class="contentClass">
          <slot name="header.prepend" />

          <THeader
            v-if="!hideDefaultHeader"
            v-model="coluna_ordenacao"
            v-bind="{headers, loading, showExpand, colorShowSelect, showSelect, desativar_ordenacao, column_drag, showColumnCustom, idUniquePreference}"
            :qtdItens="items.length"
            :icon-primary="itensFiltrados.length === modelValue.length && modelValue.length > 0"
            :icon-minus-box="modelValue.length > 0"
            style="z-index: 2"
            @select-all="updateModelValue(itensFiltrados)"
            @clear-select="updateModelValue([])"
            @update:column-drag="ev => (column_drag = ev)"
            @click:th="ev =>  $emit('click:th', ev)"
            @headers:update="(e) => forcarRenderTabela(e)"
          >
            <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"><slot :name="slot" v-bind="scope"/></template>
          </THeader>

          <tbody>
            <HeightHelp :height="heightHelpTop" :count-headers="headers.length" />

            <template v-for="row in rangeItemsVisible">
              <Row
                :key="row[itemKey]"
                v-bind="{itens_expandidos, row, headers, itemHeight, arrayItemKeySelected, itemClass, showExpand, colorShowSelect, showSelect, hideBorderBottomTr, column_drag, showColumnCustom}"
                :count-headers="headers.length"
                @click:row="clickRow"
                @dblclickRow:row="ev => $emit('dblclickRow:row', ev)"
                @contextmenu:row="contextMenuRow"
                @item-selected="selectItem"
                @item-expanded="expandItem"
                @contextmenu:column="ev => $emit('contextmenu:column', ev)"
              >
                <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"><slot :name="slot" v-bind="scope"/></template>
              </Row>

              <slot v-if="itens_expandidos.includes(row)" name="expanded-item" :headers="headers" :item="row" />
            </template>

            <RowText v-if="loading && items.length === 0" text="Carregando itens... aguarde." :count-headers="headers.length" />
            <RowText v-else-if="(items.length === 0)" :text="noDataText" :count-headers="headers.length" />
            <RowText v-else-if="(itensFiltrados.length === 0)" :text="noResultsText" :count-headers="headers.length" />

            <slot name="body.append_fixed" />
          </tbody>
        </table>
      </div>
    </div>

    <TFooter v-if="!hideDefaultFooter" :countItems="itensFiltrados.length" style="z-index: 2" :count-headers="headers.length">
      <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"><slot :name="slot" v-bind="scope"/></template>
    </TFooter>
  </div>
</template>

<script>
import props from "./IndexProps.js";
import HeightHelp from "./HeightHelp";
import TTitle from "./TTitle";
import THeader from "./THeader";
import Row from "./Row";
import TFooter from "./TFooter";
import RowText from "./RowText";
import ordenaItensPorColuna from "./helpers/sortItems"

export default {
  name: "Index",
  components: {
    RowText,
    TFooter,
    TTitle,
    THeader,
    Row,
    HeightHelp
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props,
  provide: function () {
    return {
      showExpand: this.showExpand,
      itemKey: this.itemKey,
      fixedHeader: this.fixedHeader,
    };
  },
  data: () => ({
    heightTopTable: 0,
    itens_expandidos: [],
    coluna_ordenacao: {},
    column_drag: {},
    tableRenderKey: 0,
    inits: 0,
  }),
  computed: {
    styleContentTable() {
      return {
        height: `${this.height}px`,
        borderRadius: '5px',
        overflowY: 'auto',
      };
    },
    itensFiltrados() {
      if (!this.search || this.search.trim().length === 0) {
        return this.items;
      }

      const PESQUISA_ITEM = value => `${value}`.trim().toUpperCase().includes(`${this.search}`.trim().toUpperCase());

      const callback = (this.callbackFilterSearch !== undefined)
        ? this.callbackFilterSearch
        : item => Object.values(item).some(PESQUISA_ITEM);

      return this.items.filter(callback);
    },
    _itemsFinal() {
      const aux = [].concat(this.itensFiltrados);

      if (this.$scopedSlots['body.prepend']) {
        aux.unshift({ _slot: 'body.prepend'});
      }

      if (this.$scopedSlots['body.append']) {
        aux.push({ _slot: 'body.append'});
      }
      return aux;
    },
    maxFirstItemVisible() {
      return (this._itemsFinal.length - 1) - this.lengthItemsVisible;
    },
    firstItemVisible() {
      const indexItem = Math.floor(this.heightTopTable / this.itemHeight);

      if (this.maxFirstItemVisible < 0 || indexItem <= this.maxFirstItemVisible) {
        return indexItem;
      }
      return this.maxFirstItemVisible;
    },
    lastItemVisible() {
      return (this.firstItemVisible + this.lengthItemsVisible);
    },
    lengthItemsVisible(){
      return parseInt(this.height / this.itemHeight);
    },
    arrayItemKeySelected() {
      return this.Helpers.arrayColumn(this.modelValue, this.itemKey);
    },
    rangeItemsVisible() {
      if (this.disabledScrollVirtual) {
        return this._itemsFinal;
      }
      return this._itemsFinal.slice(this.firstItemVisible, this.lastItemVisible + 2)
    },
    heightHelpTop() {
      if (this.disabledScrollVirtual) {
        return 0;
      }
      if ((this.firstItemVisible * this.itemHeight) <= 0) {
        return 0;
      }
      return this.firstItemVisible * this.itemHeight
    },
    heightRowHelpBottom() {
      if (this.disabledScrollVirtual) {
        return 0;
      }
      const height = ((this._itemsFinal.length - 1) - this.lastItemVisible) * this.itemHeight;
      return (height > 0) ? height : 0
    }
  },
  watch: {
    height() {
      this.prevenirTelaBrancaAposAtualizacao();
    },
    items: {
      handler: function () {
        if (this.items.length === 0) {
          this.heightTopTable = 0;
        }

        if ((this.items.length * this.itemHeight) <= this.height) {
          this.heightTopTable = 0;
        }

        this.addIndexOfNoItem();
      },
      immediate: true
    },
    'items.length': {
      handler() {
        this.ordenarPorColuna();
      }
    },
    search() {
      this.heightTopTable = 0;
    },
    heightTopTable: {
      handler() {},
      flush: true,
    },
    coluna_ordenacao() {
      this.ordenarPorColuna();
    }
  },
  methods: {
    ordenarPorColuna() {
      if (this.desativar_ordenacao) {
        return;
      }

      if (!this.coluna_ordenacao.value) return;

      this.$emit("ordernar-coluna-selecionada", this.coluna_ordenacao);

      if (this.ativar_ordenacao_manual) {
        return;
      }

      this.ordenaItensPorColuna(this.items, this.coluna_ordenacao.value, this.coluna_ordenacao.order);
    },
    ordenaItensPorColuna,
    addIndexOfNoItem() {
      this.items.forEach((item, index) => (item.index_of = index));
    },
    clickRow(ev) {
      this.$emit('click:row', ev);
    },
    contextMenuRow(ev) {
      this.$emit('contextmenu:row', ev);
    },
    prevenirTelaBrancaAposAtualizacao() {
      this.$refs.contentTableRef.scrollTop += 1;
    },
    async onScrollTable(ev) {
      this.$emit('scroll-items', ev.target);
      this.heightTopTable = ev.target.scrollTop;
    },
    selectItem(item) {
      let novaModelValue;

      if (this.selectedItem(item)) {
        novaModelValue = this.unselectItemModelValue(item);
      } else {
        novaModelValue = this.selectItemModelValue(item);
      }

      this.updateModelValue(novaModelValue);
    },
    updateModelValue(valores) {
      this.$emit("update:modelValue", valores);
    },
    selectedItem(item) {
      return this.arrayItemKeySelected.includes(item[this.itemKey]);
    },
    unselectItemModelValue(item) {
      return this.modelValue.filter(value => (item[this.itemKey] !== value[this.itemKey]));
    },
    selectItemModelValue(item) {
      return [].concat(this.modelValue, item);
    },
    contextmenu(ev) {
      this.$emit('contextmenu', ev);
    },
    expandItem(row) {
      const item_expandido = this.itens_expandidos.includes(row);

      this.$emit('item-expanded', {item: row, value: item_expandido})

      if (item_expandido) {
        this.itens_expandidos = this.itens_expandidos.filter(item => item !== row);
        return;
      }

      if (this.singleExpand) {
        this.itens_expandidos = [row];
      } else {
        this.itens_expandidos.push(row);
      }
    },
    forcarRenderTabela(tipo = null) {
      if (tipo !== null && tipo === 'init' && this.inits <= 0) {
        this.inits++
        this.tableRenderKey++;
        return;
      }

      if (tipo !== null && tipo === 'update') {
        this.tableRenderKey++;
      }
    }
  }
}
</script>

<style scoped>
table {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  color: #2d2d2d;
}
table tr:hover {
  background-color: #EEEEEE !important;
}
</style>
